<div class="contacto-wrapper">
  <div class="contacto-container">
    <div class="contacto-grid">
      <!-- Columna izquierda: info de contacto y sede -->
      <div class="contacto-info">

        <div class="info-card">
          <h6 class="info-label emergency">EMERGENCIAS Y URGENCIAS 24HS:</h6>
          <a href="tel:08003331147" class="btn-contacto emergency-btn">
            <span class="material-icons">phone</span>
            0800-333-1147
          </a>
        </div>


        <div class="info-card">
          <h6 class="info-label medical">ATENCIÓN DEL AFILIADO:</h6>
          <a href="tel:08103334485" class="btn-contacto mb-3">
            <span class="material-icons">phone</span>
            0810-333-4485
          </a>

          <h6 class="info-label medical">AUDITORÍA MÉDICA:</h6>
          <a href="https://wa.me/+5401167164074" target="_blank" class="btn-contacto">
            <i class="fab fa-whatsapp"></i>
            Escribinos por WhatsApp
          </a>
        </div>

        <hr class="divider">

        <!-- Sede asociada al afiliado (si existe) -->
        <div class="info-card sede-card" *ngIf="this.sede && this.sede !== null">
          <h3>Atención al Socio</h3>
          <h5>{{this.sede.nombre}}</h5>
          <div class="sede-datos">
            <p *ngIf="this.sede?.direccion"><strong>Dirección:</strong> {{this.sede?.direccion}}</p>
            <p *ngIf="this.sede?.email"><strong>Email:</strong> {{this.sede?.email}}</p>
            <p *ngIf="this.sede?.horario"><strong>Horario:</strong> {{this.sede?.horario}}</p>
          </div>
          <div class="sede-botones">
            <a [href]="'tel:' + this.sede.telefono1" class="btn-contacto small">
              <span class="material-icons">phone</span>
              {{this.sede.telefono1}}
            </a>
            <a *ngIf="this.sede?.telefono2" [href]="'tel:' + this.sede?.telefono2" class="btn-contacto small">
              <span class="material-icons">phone</span>
              {{this.sede?.telefono2}}
            </a>
            <a [href]="'https://wa.me/'+this.sede?.whatsapp" target="_blank" class="btn-contacto small">
              <i class="fab fa-whatsapp"></i>
              Escribinos
            </a>
          </div>
        </div>
      </div>

      <!-- Columna derecha: formulario de contacto -->
      <div class="contacto-form">
        <div class="form-card">
          <h3>Complete el siguiente formulario para contactarnos</h3>

          <form [formGroup]="form" (ngSubmit)="submit()">
            <div class="form-group">
              <label for="email">Correo electrónico</label>
              <input
                formControlName="email"
                type="email"
                id="email"
                class="form-control"
                [class.is-invalid]="emailNoValido"
                placeholder="Ingrese su correo electrónico"
              >
              <small *ngIf="emailNoValido" class="error-msg">Ingrese un correo electrónico válido</small>
            </div>

            <div class="form-group">
              <label for="mensaje">Mensaje</label>
              <textarea
                formControlName="mensaje"
                id="mensaje"
                rows="5"
                class="form-control"
                placeholder="Ingrese su mensaje"
              ></textarea>
            </div>

            <div class="form-group checkbox-group">
              <mat-checkbox formControlName="clausula">
                <em>He leído y acepto los
                  <a (click)="openBlank('TC')" class="link-inline">Términos y Condiciones</a>
                </em>
              </mat-checkbox>
            </div>

            <div class="form-group checkbox-group">
              <mat-checkbox formControlName="proteccionDeDatos">
                <em>Autorizo el tratamiento de mis datos para recibir información
                  <a (click)="openBlank('CFA')" class="link-inline">Cláusula Registro</a>
                </em>
              </mat-checkbox>
            </div>

            <button type="submit" [disabled]="!form.valid" class="btn-submit">
              Enviar formulario
              <span class="material-icons">send</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Mapa -->
<div id="map">
  <iframe
    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3282.958054307627!2d-58.46945512425863!3d-34.6305002729447!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bcc988ec57119f%3A0xb6720547b143969b!2sCulpina%2031%2C%20C1406ENA%20CABA!5e0!3m2!1ses!2sar!4v1698321668755!5m2!1ses!2sar"
    width="600"
    height="450"
    style="border:0;"
    allowfullscreen=""
    loading="lazy"
    referrerpolicy="no-referrer-when-downgrade">
  </iframe>
</div>